<template>
  <div v-loading="loading" class="GmzGxhtxxHome">
    <div class="_title">
      <p class="_title_info">查询购销合同</p>
    </div>
    <el-form
      ref="searchForm"
      label-position="right"
      class="_jbxxForm"
      label-width="200px"
    >
      <el-form-item label="购买证编号：" prop="xkzBh">
        <el-input v-model="xkzBh" />
      </el-form-item>
      <div class="buttonList">
        <el-button @click="reset"> 重 置 </el-button>
        <el-button type="primary" @click="submit"> 搜 索 </el-button>
      </div>
    </el-form>
    <div v-if="localData"
         style="margin: auto;
        width: 95%;
        max-width: 1518px;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 57px;">
      <div>购买证购销合同</div>

      <div v-if="localData.wjdzList != null && localData.wjdzList.length >  0">
        <div class="demo-image__preview showYszGxht"   v-for="picUrl in localData.wjdzList" >
          <el-image
            style="width: 200px; height: 200px"
            :src="getPicUrl(picUrl)"
            :preview-src-list="getPicUrlArr(picUrl)"></el-image>
        </div>
      </div>
      <div v-else style="color: red;margin: 20px;">
        购买证无购销合同
      </div>


      <div style="margin-top:20px;">
        <span>相关运输证</span>
        <div class="tablemes" style="margin-top:20px;">
          <el-table
            ref="yszTabel"
            :data="localData.yszDtos"
            border
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
          >
            <el-table-column
              prop="xkzBh"
              label="运输证编号"
            />
            <el-table-column
              prop="hxpMc"
              label="化学品"
            />
            <el-table-column
              label="核准数量"
            >
              <template slot-scope="scope">
                {{scope.row["xkzSl"] +
                "  (" +
                scope.row["xkzSlDwLabel"] +
                ")"}}
              </template>
            </el-table-column>
            <el-table-column
              prop="fhdwMc"
              label="发货单位"
            />
            <el-table-column
              prop="shdwMc"
              label="收货单位"
            />
            <el-table-column
              prop="ysdwMc"
              label="运输单位"
            />
            <el-table-column
              prop="hfrq"
              label="核发时间"
            />
            <el-table-column label="操作" align="center" width="200px">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.zt != '00'"
                  v-preventReClick
                  type="primary"
                  icon="el-icon-document"
                  size="mini"
                  @click="getYszGxht(scope.$index, scope.row)"
                >查看合同</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog :title="'运输证'+yszBh+'的购销合同'" :visible.sync="updFlag" >
      <div class="demo-image__preview showYszGxht" v-for="yszurl in yszGxhtData.wjdzList" >
        <el-image
          style="width: 200px; height: 200px"
          :src="getPicUrl(yszurl)"
          :preview-src-list="getPicUrlArr(yszurl)"></el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { gmzGxhtxxData,yszGxhtxxData } from '@/assets/js/system.js'
import {returnShowPic} from "@/assets/js/common";
export default {
  name: 'GmzGxhtxx',
  data() {
    return {
      dwVipLevel:'',
      updFlag: false,
      loading: false,
      xkzBh: '',
      yszBh:'',
      localData: false,
      yszGxhtData: '',
      labelStyle:{'width' : '200px'},
    }
  },
  mounted(){},
  methods: {
    getPicUrl(picUrl){
      return returnShowPic()+picUrl
    },
    getPicUrlArr(picUrl){
      let picArr = []
      picArr.push(returnShowPic()+picUrl)
      return picArr
    },
    reset() {
      this.xkzBh = ''
      this.localData = false
    },
    submit() {
      if (!this.xkzBh) {
        this.$message.warning('许可证编号不能为空')
        return
      }
      this.loading = true
      gmzGxhtxxData(this.xkzBh)
        .then((e) => {
          this.loading = false
          this.localData = e.data.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    getYszGxht(index,ysz){
      this.yszBh = ysz.xkzBh
      this.yszGxhtData = ''
      yszGxhtxxData(ysz.xkzId)
        .then((e) => {
          this.yszGxhtData = e.data.data
          if(this.yszGxhtData != null && e.data.data.wjdzList != null && e.data.data.wjdzList.length > 0){
            this.updFlag = true
          }else{
            this.$message.warning('该运输证没有购销合同!')
          }
        })
        .catch(() => {
        })
    }
  }
}
</script>

<style lang='less' scoped>
.GmzGxhtxxHome {
  overflow-y: auto;
  padding: 20px;
  background-color: white;
  margin: 10px;
  height: calc(100% - 20px);
  ._title {
    margin-top: 50px;
    width: 100%;
    ._title_info {
      text-align: center;
      font-size: 23px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #434343;
      line-height: 32px;
      height: 32px;
      font-family: Helvetica;
    }
  }
  ._jbxxForm {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 100px auto 0px auto;
    width: 50%;

    .el-form-item {
      margin-right: 0;
      width: 100%;
      /deep/.el-form-item__content {
        display: flex !important;
      }
    }
  }
  .buttonList {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 20px auto 0px auto;
    width: 50%;
  }

  .showYszGxht{
    display: inline-block;
    width: 200px;
    height: 200px;
    margin-right: 20px ;
    margin-top: 20px ;
  }

  /deep/ .el-dialog .el-dialog__body {
    height: 650px !important;
    overflow-y: auto !important;
  }
}
</style>
